import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode"; // Biblioteca para decodificar o JWT
import { FaRegClock } from "react-icons/fa"; // Ícone de relógio (FaRegClock)

const TokenCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Pegando o token armazenado no localStorage
    const token = localStorage.getItem("@medusapayments:access_token");

    if (token) {
      try {
        // Decodificando o JWT
        const decodedToken = jwt_decode(token);

        // O campo "exp" é o timestamp Unix (segundos), então multiplicamos por 1000 para convertê-lo para milissegundos
        const expiryTime = decodedToken.exp * 1000; // Expiração em milissegundos
        const currentTime = Date.now(); // Hora atual em milissegundos
        const remainingTime = expiryTime - currentTime; // Calcula o tempo restante

        if (remainingTime > 0) {
          setTimeLeft(remainingTime); // Definindo o tempo restante
        } else {
          // Caso o tempo já tenha expirado, redirecionar imediatamente
          navigate("/");
        }

        // Atualizando a contagem regressiva a cada segundo
        const interval = setInterval(() => {
          setTimeLeft((prevTime) => {
            if (prevTime <= 1000) {
              clearInterval(interval);
              navigate("/"); // Redirecionar quando o tempo acabar
              return 0;
            }
            return prevTime - 1000;
          });
        }, 1000);

        return () => clearInterval(interval); // Limpa o intervalo quando o componente desmonta
      } catch (error) {
        navigate("/"); // Redireciona em caso de erro ao decodificar o token
      }
    } else {
      // Caso o token não exista
      navigate("/");
    }
  }, [navigate]);

  const formatTime = (time) => {
    const seconds = Math.floor((time / 1000) % 60);
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${
      seconds < 10 ? "0" : ""
    }${seconds}`;
  };

  return (
    <div className="flex flex-col text-[13px]  text-slate-600 justify-center   ">
      <p className="   text-slate-600">
        Conexão
        <span className="ml-2">
          {/* Espaço entre o texto e o ícone */}

          <FaRegClock className="inline-block mr-1  text-slate-600" />
        </span>
        <b> {formatTime(timeLeft)}</b>
      </p>
    </div>
  );
};

export default TokenCountdown;
